// extracted by mini-css-extract-plugin
module.exports = {"container":"ConfirmAccount_container__1GuhV","card":"ConfirmAccount_card__RImrC","icon":"ConfirmAccount_icon__MhNr_"};